import { useState as n, useEffect as E } from "react";
import { getConfig as p } from "./help-center-knowledge-anatomies7.js";
const m = (r, t, o, f) => {
  const [l, h] = n(null), [u, i] = n(!1), [g, a] = n(null);
  return E(() => {
    if (!r || !t)
      return;
    (async () => {
      try {
        i(!0), a(null);
        const e = `${p(o).hcServiceUrl}/v2/vistaprint/${t.toLowerCase()}/articles/${r}`, c = await fetch(e, {
          method: "GET"
        });
        if (!c.ok)
          throw new Error(`HTTP error! Status: ${c.status}`);
        const w = await c.json();
        h(w);
      } catch (s) {
        const e = s instanceof Error ? s.message : "An error occurred while fetching the article";
        a(e), f?.error("Error fetching article", {
          error: e,
          context: {
            articleNumber: r,
            locale: t,
            useStaging: o
          }
        });
      } finally {
        i(!1);
      }
    })();
  }, [r, t, o]), { article: l, loading: u, error: g };
};
export {
  m as useArticle
};
//# sourceMappingURL=help-center-knowledge-anatomies6.js.map
